
import { Card } from "@/components/ui/card"
import type { BillingStats as BillingStatsType } from "../types"

interface BillingStatsProps {
  stats: BillingStatsType
}

export function BillingStats({ stats }: BillingStatsProps) {
  const formatCurrency = (cents: number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      maximumFractionDigits: 0
    }).format(cents)
  }

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Total Revenue</span>
        <span className="text-2xl font-bold mt-2">{formatCurrency(stats.totalRevenue)}</span>
        <div className="mt-1 text-xs text-muted-foreground">{stats.paidCount} paid invoices</div>
      </Card>
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Pending Payment</span>
        <span className="text-2xl font-bold mt-2 text-blue-600">{formatCurrency(stats.pendingAmount)}</span>
        <div className="mt-1 text-xs text-muted-foreground">{stats.pendingCount} invoices sent</div>
      </Card>
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Overdue</span>
        <span className="text-2xl font-bold mt-2 text-red-600">{formatCurrency(stats.overdueAmount)}</span>
        <div className="mt-1 text-xs text-red-600 font-medium animate-pulse">{stats.overdueCount} invoices overdue</div>
      </Card>
    </div>
  )
}
